module.exports = __webpack_public_path__ + "site/img/118.5e55ed9a.jpg";